<template>
  <div id="app">

    <div class="row" v-if="showLoader">

      <div class="col-12">

        <h2 class="text-center">Refreshing Vehicles</h2>
        <img class="d-block mx-auto p-3" src="/images/site/loaders/loading.svg" />

      </div>

    </div>

    <div v-if="!showLoader" v-cloak>

      <div class="row">

        <div class="col-12">

          <ol class="breadcrumb">

            <li class="breadcrumb-item"><span><a href="/">Continental Auto Group</a></span></li>

            <li v-if="$route.name === 'new'" class="breadcrumb-item active"><span><a href="/vehicles/new/continental">New Vehicles</a></span></li>
            <li v-if="$route.name === 'used'" class="breadcrumb-item active"><span><a href="/vehicles/new/continental">Pre-Owned Vehicles</a></span></li>

          </ol>

        </div>

      </div>

      <div class="row mb-2 mb-lg-0">

        <div class="col-12">

          <h5 class="d-block mb-3 pb-3"><span class="float-left">{{ $root.niceStockType }} Vehicles </span><span class="total_vehicles float-right"><svg class="icon icon-info"><use xlink:href="/assets/svg/symbol-defs.svg#icon-info"></use></svg>&nbsp;<strong>{{ totalNumCars }}</strong> Matches </span></h5>
        </div>

        <div class="col-12">

          <span v-b-toggle.collapse-1 class="text-center">
            <a href="#" @click.prevent class="d-block d-lg-none border border-primary">
              <button id="vehicle-hamburger" class="hamburger vehicle-hamburger--slider trigger_search_filters" type="button" title="Menu">
                <span class="hamburger-box">
                  <span class="hamburger-inner"></span>
                </span>
              </button>
              <span class="large mb-3 text-right" style="font-size: 200%;">FILTER &amp; SORT</span>
            </a>
          </span>

        </div>
      </div>

      <div class="row">

        <div class="col-12 col-lg-3">

          <b-collapse id="collapse-1" class="d-lg-block">
            <nav>
              <SearchFilters
                :displayResults="displayResults"
                :yearsVisible.sync="yearsVisible"
                :modelVisible.sync="modelVisible"
                :queryPopulated="queryPopulated"
                :makeVisible.sync="makeVisible"
                :bodyTypeVisible.sync="bodyTypeVisible"
                :priceVisible.sync="priceVisible"
                :max_price="max_price"
              >
              </SearchFilters>
            </nav>
          </b-collapse>
        </div>

        <div class="col-12 col-lg-9" id="right_column">

          <router-view/>

        </div>

      </div>

    </div>

  </div>
</template>

<script>

// car search app components
import SearchFilters from '@/components/SearchFilters.vue'

import axios from 'axios'

// import bootstrap-vue components
import { VBToggle, BCollapse } from 'bootstrap-vue'

import { mapState } from 'vuex'

export default {
  name: 'CarSearchApp',
  components: {
    SearchFilters,
    BCollapse
  },
  directives: {
    'b-toggle': VBToggle,
    'b-collapse': BCollapse
  },
  data () {
    return {
      showLoader: true,
      queryPopulated: false,
      mobileNavMediaQuery: this.queryMedia('max', '600'),
      makeVisible: true,
      modelVisible: false,
      bodyTypeVisible: true,
      priceVisible: false,
      displayResults: false,
      yearsVisible: false,
      highestPrice: 0,
      seo: {
        default_title_used: 'Pre-Owned Vehicles | Continental Auto Group',
        default_title_new: 'New Vehicles | Continental Auto Group',
        default_title_all: 'All Vehicles | Continental Auto Group'
      }
    }
  },
  computed: {
    ...mapState(['searchFilters', 'pagination', 'cars', 'stockType', 'totalNumCars'])
  },
  watch: {
    '$route.query': function (to, from) {
      // console.log('$route.query triggered by watch (from): ', from)
      // console.log('$route.query triggered by watch (to): ', to)
      this.checkStockType(this.$route.name)
      this.filterVehicles()
      this.updateSEO()
    }
  },
  beforeCreate: function () {
  },
  created: function () {
    // if super-admin (1) or owner (12)
    if (window.Cag.user.group_id === '1' || window.Cag.user.group_id === '12') {
      // grab manager's JSON file above web root
      this.$store.dispatch('storeCarInventory', window.Cag.car_inventory)
      this.max_price = Number(window.Cag.car_inventory.max_price)
      this.showLoader = false
    } else {
      // get public inventory via AJAX
      if (typeof (window.Cag.car_inventory_filename) === 'undefined') {
        console.log('Error retrieving vehicle inventory.')
      }
      const filename = window.Cag.car_inventory_filename
      var url = '//' + location.hostname + '/assets/car-search/' + filename

      // perform ajax call
      axios.get(url)
        .then(response => {
          // console.log(response)
          this.$store.dispatch('storeCarInventory', response.data)
          this.max_price = Number(response.data.max_price)
          this.filterVehicles()

          // remove loading animation
          this.showLoader = false
        })
        .then(() => {
          this.displayResults = true
        })
        .catch(e => {
          console.log(e)
        })
    }
  },
  beforeMount: function () {
    // console.log('beforeMount')
    this.initMount()
    this.checkStockType(this.$route.name)

    // if logged in, we need to run 'filterVehicles()' manually since there's no initial ajax request once app is loaded
    if (window.Cag.user.group_id === '1' || window.Cag.user.group_id === '12') {
      this.filterVehicles()
    }
    this.displayResults = true
  },
  mounted: function () {
    // console.log(window)
  },
  methods: {
    scrollTop: function () {
      window.scroll({
        top: 0,
        behavior: 'smooth'
      })
    },
    queryMedia (minMax, width) {
      const matchWidth = '(' + minMax + '-width: ' + width + 'px)'
      window.matchMedia(matchWidth).addListener(e => {
        this.mobileNavMediaQuery = e.matches
      })
    },
    checkStockType: function (newStockType) {
      if (newStockType !== this.$store.state.stockType) {
        if (newStockType === 'new') {
          this.$store.dispatch('storeStockType', 'new')
        }
        if (newStockType === 'used') {
          this.$store.dispatch('storeStockType', 'used')
        }
        if (newStockType === 'all') {
          this.$store.dispatch('storeStockType', 'all')
        }
      }
    },
    /**
     * Initialize on mount
     */
    initMount: function () {
      // set our inital variables from our url query string
      // some fields need to be arrays, even if it's initially a string
      this.searchFilters.make = this.getSelectedInitVar(this.$route.query, 'make', 'array')
      this.searchFilters.model = this.getSelectedInitVar(this.$route.query, 'model', 'array')
      this.searchFilters.body_type = this.getSelectedInitVar(this.$route.query, 'body_type', 'array')
      this.searchFilters.year = this.getSelectedInitVar(this.$route.query, 'year', 'array').map(num => parseInt(num))
      this.searchFilters.sortBy = this.$route.query.sortBy
      this.searchFilters.sortType = this.$route.query.sortType
      this.searchFilters.page = this.$route.query.page
      this.searchFilters.keyword = this.$route.query.keyword
      this.searchFilters.show_specials = typeof (this.$route.query.show_specials) !== 'undefined' ? String(this.$route.query.show_specials) : undefined
      this.searchFilters.certified = typeof (this.$route.query.certified) !== 'undefined' ? Boolean(this.$route.query.certified) : undefined
      this.searchFilters.fresh = typeof (this.$route.query.fresh) !== 'undefined' ? Number(this.$route.query.fresh) : undefined
      this.searchFilters.startPrice = typeof (this.$route.query.startPrice) !== 'undefined' ? Number(this.$route.query.startPrice) : undefined
      this.searchFilters.endPrice = typeof (this.$route.query.endPrice) !== 'undefined' ? Number(this.$route.query.endPrice) : undefined
      this.searchFilters.status_group = this.getSelectedInitVar(this.$route.query, 'status_group', 'array')

      if (typeof (this.$route.query.viewFormat) === 'undefined') {
        this.$store.dispatch('storeViewFormat', 'grid')
      } else {
        this.$store.dispatch('storeViewFormat', this.$route.query.viewFormat)
      }

      if (this.searchFilters.make.length > 0 || this.searchFilters.body_type.length > 0) {
        this.modelVisible = true
      }

      if (this.searchFilters.year.length > 0) {
        this.yearsVisible = true
      }

      if (typeof (this.searchFilters.startPrice) !== 'undefined' || typeof (this.searchFilters.endPrice) !== 'undefined') {
        this.priceVisible = true
      }

      // save our filters to state
      this.$store.dispatch('storeSearchFilters', this.searchFilters)
    },
    /**
    * Filter vehicles
    */
    filterVehicles: function () {
      // console.log('filterVehicles')
      // make copy of this.$store.state.cars so we can filter down
      var baseVehicleInventory = this.cars

      if (this.stockType !== 'all') {
        // show the requested stock type
        baseVehicleInventory = this.$root._.filter(baseVehicleInventory, { stock_type: this.stockType })
      }

      this.searchFilters.year = this.searchFilters.year.map(num => parseInt(num))

      // if specials checkbox is selected
      if (this.searchFilters.show_specials === '1') {
        baseVehicleInventory = this.$root._.filter(baseVehicleInventory, (car) => {
          if (car.stock_type === 'new') {
            if (car.dealer_discount > 0 || car.total_cash_incentives > 0) {
              return true
            }
          }
          if (car.stock_type === 'used') {
            return car.book_value > 0
          }
        })
      }

      // if (this.searchFilters.status === 'In-Transit') {
      //   baseVehicleInventory = this.$root._.filter(baseVehicleInventory, (car) => {
      //     if (car.status === 'Reserved') {
      //       return car
      //     }
      //   })
      // }

      // if (this.searchFilters.status === 'In-Stock') {
      //   baseVehicleInventory = this.$root._.filter(baseVehicleInventory, (car) => {
      //     return car.status === 'In-Stock'
      //   })
      // }

      if (this.searchFilters.fresh === true) {
        baseVehicleInventory = this.$root._.filter(baseVehicleInventory, (car) => {
          return car.fresh === 1
        })
      }

      // if certified checkbox is selected
      if (this.searchFilters.certified === true) {
        baseVehicleInventory = this.$root._.filter(baseVehicleInventory, (car) => {
          return car.certified !== 'N'
        })
      }

      if (!this.$root._.isEmpty(this.searchFilters.body_type)) {
        baseVehicleInventory = this.$root._.filter(baseVehicleInventory, (car) => {
          if (this.$root._.includes(this.searchFilters.body_type, car.body_type)) {
            return car
          }
        })
      }

      // price filter
      if (this.searchFilters.startPrice > 0) {
        baseVehicleInventory = this.$root._.filter(baseVehicleInventory, (car) => {
          return car.final_price > this.searchFilters.startPrice
        })
      }
      if (this.searchFilters.endPrice > 0) {
        baseVehicleInventory = this.$root._.filter(baseVehicleInventory, (car) => {
          return car.final_price < this.searchFilters.endPrice
        })
      }

      // keep track of whether there's query params in the url
      this.queryPopulated = this.isQueryPopulated()

      let totalVehicles = 0
      if (baseVehicleInventory !== null) {
        totalVehicles = baseVehicleInventory.length
      }

      // empty array for storing our matched vehicles
      var returnData = []

      for (var i = 0; i < totalVehicles; i++) {
        var matched = this.filterFunnel(baseVehicleInventory[i])
        if (matched === true) {
          returnData.push(baseVehicleInventory[i])
        }
      }

      // return all vehicles if no vehicle filters selected
      if (!this.queryPopulated && this.$root._.isEmpty(returnData)) {
        returnData = baseVehicleInventory
      }

      // sort our vehicles
      returnData = this.sortVehicles(returnData)

      // console.log('returnData', returnData)

      // count number of vehicles total
      var totalNumCars = returnData.length
      this.$store.dispatch('storeTotalNumCars', totalNumCars)

      // update pagination (now that we have totalNumCars)
      this.updatePagination()

      // chunk vehicle data for paging
      const carsPerPage = 50
      returnData = this.$root._.chunk(returnData, carsPerPage)

      // check whether we should show index 0 of inventory
      // or actual page number
      if (typeof (this.pagination) === 'undefined') {
        // return index 0 of inventory
        returnData = returnData[0]
      } else {
        if (typeof (this.pagination.currentPage) !== 'undefined') {
          // return correct page index
          var pageIndex = this.pagination.currentPage - 1
          returnData = returnData[pageIndex]
        } else {
          returnData = returnData[0]
        }
      }

      // save our car results to state
      this.$store.dispatch('storeFilteredCars', returnData)
    },
    /**
    * Sort Vehicles
    */
    sortVehicles: function (cars) {
      var sortedCars
      var defaultSort = ''

      if (typeof (this.searchFilters.sortBy) === 'undefined') {
        // set default sort if no sort selected
        if (this.stockType === 'new') {
          defaultSort = 'dealer_discount'
        } else {
          defaultSort = 'book_value'
        }
        sortedCars = this.$root._.orderBy(cars, [(o) => { return o[defaultSort] || '' }], 'desc')
        return sortedCars
      } else {
        // if sortBy is defined, use it
        var sortBy = this.searchFilters.sortBy
        var sortType = this.searchFilters.sortType

        sortedCars = this.$root._.orderBy(cars, sortBy, sortType)
        return sortedCars
      }
    },
    /**
    * Populate the var - used for input v-models
    */
    getSelectedInitVar: function (searchFilters, varName, varType) {
      // if it's undefined: return an empty varType
      if (typeof (searchFilters[varName]) === 'undefined') {
        switch (varType) {
          case 'string':
            return ''
          case 'array':
            return []
          default:
            return ''
        }
      }

      // if it's an object: return selected vars
      if (typeof (searchFilters[varName]) === 'object') {
        return searchFilters[varName]
      }

      // if it's a string: return selected vars
      if (typeof (searchFilters[varName]) === 'string') {
        var returnData = []
        returnData.push(searchFilters[varName])
        return returnData
      }

      return []
    },
    /**
    * Get results after using searchFilters
    */
    searchFiltersChanged: function () {
      // show our loader animation
      this.showLoader = true

      // flash a loading screen for split second
      setTimeout(function () {
        this.filterVehicles()
        this.showLoader = false
      }.bind(this), 42)
    },
    /**
     * Update pagination object
     */
    updatePagination: function () {
      var currentPage = 1

      // if currentPage is undefined, set currentPage to 1
      if (typeof (this.searchFilters) !== 'undefined') {
        if (typeof (this.searchFilters.page) !== 'undefined') {
          currentPage = this.searchFilters.page
        }
      }

      // cast string to int
      currentPage = parseInt(currentPage)

      // set currentPage
      this.pagination.currentPage = currentPage

      // set pageIndex
      this.pagination.pageIndex = this.pagination.currentPage - 1

      // calculate and set totalPages
      this.pagination.totalPages = Math.ceil(this.totalNumCars / this.pagination.perPage)

      // set previousPage
      this.pagination.previousPage = this.pagination.currentPage - 1

      // set nextPage
      this.pagination.nextPage = (this.pagination.totalPages !== this.pagination.currentPage ? this.pagination.currentPage + 1 : this.pagination.currentPage)

      // save our pagination to store.state
      this.$store.dispatch('storePagination', this.pagination)
    },
    /**
     * filterFunnel - Runs inside loop for each vehicle in inventory
     * @param {Object} car
     */
    filterFunnel (car) {
      // should we return this car to results?
      var returnCar = []

      // keyword search
      if (typeof (this.searchFilters.keyword) !== 'undefined' && this.searchFilterskeyword !== '') {
        // break apart keyword search by space
        var keywordArray = this.searchFilters.keyword.split(' ')
        var numKeywords = keywordArray.length

        var numMatches = 0

        // loop through each keyword from keywordArray
        for (var keywordKey in keywordArray) {
          // assign keyword
          // cast to string them to lowercase
          const keyword = keywordArray[keywordKey].toString()

          // loop thru fields to search; match keyword search to car value
          for (const carKey in car.keywords) {
            // assign keyword to carVal
            var carVal = car.keywords[carKey]

            // build regex for searching
            var regex = new RegExp('\\b' + keyword + '\\b', 'gi')

            // check if car field value contains search keyword
            var isMatch = regex.test(carVal)
            if (isMatch === true) {
              numMatches++
            }
          }
        }
        if (numMatches >= numKeywords) {
          returnCar.push(true)
        } else {
          return false
        }
      }

      // fields which don't count towards populating query
      const notPopFields = this.$root.notPopFields

      // loop thru searchFilters
      for (var filterKey in this.searchFilters) {
        // if filterKey is field which doesn't count as a searchFilter, skip
        if (this.$root._.includes(notPopFields, filterKey)) {
          continue
        }

        // assign filter value
        var filterVal = this.searchFilters[filterKey]

        // console.log(filterKey, filterVal)

        // searchFilter fields to skip when filtering vehicles; could be used for other preset data
        const skipTheseFields = ['viewFormat', 'keyword']

        // skip the undefined searchFilters && keyword field
        if (typeof (filterVal) !== 'undefined' && !skipTheseFields.includes(filterKey)) {
          // skip the empty searchFilters
          if (this.$root._.size(filterVal) > 0) {
            this.queryPopulated = true

            // console.log(filterKey, filterVal, car[filterKey])

            if (this.$root._.includes(filterVal, car[filterKey])) {
              // console.log('filter: ', filterKey, filterVal)
              // console.log('car[filterKey]', car[filterKey])

              // ignore make if a model is selected.
              if (filterKey === 'make') {
                returnCar.push(true)
              }
            } else {
              // 'show_specials' searchFilter needs to be evaluated separately as it applies to car.on_special
              if (filterKey === 'show_specials') {
                if (car.on_special === 'y') {
                  returnCar.push(true)
                }
              } else {
                returnCar.push(false)
              }
            }
          }
        }
      }
      if (this.$root._.includes(returnCar, false)) {
        return false
      } else {
        return true
      }
    },
    /**
     * Have any search filters been applied?
     * Returns boolean
     */
    isQueryPopulated () {
      for (var searchField in this.searchFilters) {
        // fields which don't count towards populating query
        const notPopFields = ['sortBy', 'sortType', 'page']
        if (this.$root._.includes(notPopFields, searchField)) {
          continue
        }
        if (typeof (this.searchFilters[searchField]) !== 'undefined') {
          if (this.$root._.size(this.searchFilters[searchField]) > 0) {
            return true
          }
        }
      }
      return false
    },
    updateSEO () {
      const eachFunction = this.$root._.each
      if (!this.$root._.isEmpty(this.searchFilters)) {
        const filters = []
        eachFunction(this.searchFilters, function (searchFilter) {
          if (typeof searchFilter === 'object') {
            eachFunction(searchFilter, function (sF) {
              if (typeof sF !== 'undefined' && sF !== '') {
                filters.push(sF)
              }
            })
          } else {
            if (typeof searchFilter !== 'undefined' && searchFilter !== '' && searchFilter.length > 0) {
              filters.push(searchFilter)
            }
          }
        })
        window.document.title = this.stockType.charAt(0).toUpperCase() + this.stockType.slice(1) + ' Vehicle Inventory '
        if (filters.length > 0) {
          window.document.title += ' | Search For: ' + filters.join(', ')
        }
        window.document.title += ' | Continental Auto Group'
        console.log(window.document.title)
      }
    }
  }
}
</script>

<style lang="scss">

  [v-cloak] { display: none; }

  /* spinner */
  .semipolar-spinner {
    z-index: 1100;
    position: fixed;
    top: 50%;
    left: 50%;
  }

  /* modal backdrop */
  .modal-backdrop.show {
    background-color: white;
  }

  .hamburger {
    padding-bottom: 8px;
  }

  .grid-view, .list-view {
    color: rgb(142, 142, 142);
  }

  .grid-view.active, .list-view.active {
    color: #17457b;
  }

  $fresh: #00B16A;
  $special: #D3282C;
  $certified: #5e2629;
  $in-stock: #0067ac;
  $reserved: #3B2B4B;
  $in-transit: #CBA80F;

  .status-square {
    width: 20px; height: 20px; display: block;
  }
  .text-fresh {
    color: $fresh!important;
  }
  .text-special {
    color: $special!important;
  }
  .text-certified {
    color: $certified!important;
  }
  .text-in-stock {
    color: $in-stock!important;
  }
  .text-reserved {
    color: $reserved!important;
  }
  .text-in-transit {
    color: $in-transit!important;
  }
  .bg-fresh {
    background-color: $fresh!important;
  }
  .bg-special {
    background-color: $special!important;
  }
  .bg-certified {
    background-color: $certified!important;
  }
  .bg-in-transit {
    background-color: $in-transit!important;
    color: #212529;
  }
  .bg-reserved {
    background-color: $reserved!important;
  }
  .border-reserved {
    border: 1px solid $reserved!important;
  }
  .bg-in-stock {
    background-color: $in-stock!important;
  }

</style>
